<template>
    <el-pagination background layout="prev, pager, next" :total="count" @current-change="pageChange" />
</template>

<script>
export default {
    props: {
        count: {
            // type: Number,
            default: 9,
        },
        type: 0,
    },
    methods: {
        pageChange(page) {
            this.$emit("pageChange", page-1);
        },
    }
};
</script>